import axios from 'axios'
const AUTH_LOCAL_STORAGE_KEY = 'cdw-auth'

const getAuth = () => {
  if (!localStorage) {
    return
  }

  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth = JSON.parse(lsValue)
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

// Only the pass download link authenticates with its own ?token=. Anywhere else a URL
// token must not reach the Authorization header: AuthInit's session check would fail
// with it and Api()'s 401 handler would sign the superadmin out. /reset-password sends
// its token in the request body.
const URL_TOKEN_PATHS = ['/generate-pass']

const isUnderPath = (pathname, base) =>
  pathname === base || pathname.startsWith(base + '/')

function urlTokenForCurrentPath() {
  if (typeof window === 'undefined') return null
  const { pathname, search } = window.location
  if (!URL_TOKEN_PATHS.some((base) => isUnderPath(pathname, base))) return null
  return new URLSearchParams(search).get('token')
}

const isSessionCheck = (url) => typeof url === 'string' && /\/auth\/verify_token(\?|$)/.test(url)

function authorizationFor(url) {
  const urlToken = urlTokenForCurrentPath()
  if (urlToken && !isSessionCheck(url)) return `Bearer ${urlToken}`
  const auth = getAuth()
  return auth && auth.token ? `Bearer ${auth.token}` : null
}

function setupAxios() {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config) => {
      const authorization = authorizationFor(config.url)
      if (authorization) config.headers.Authorization = authorization
      return config
    },
    (err) => Promise.reject(err)
  )
}

export {
  getAuth,
  setAuth,
  removeAuth,
  AUTH_LOCAL_STORAGE_KEY,
  setupAxios,
  urlTokenForCurrentPath,
}
